import { InterviewReviewItem, InterviewReviewObj } from '~hooks/query/review/useGetInterview';
import { Nullable } from '~types/common';

export interface RankedInterviewReviewItem extends InterviewReviewItem {
  rank: number;
}

export function getWidthByRank(rank?: number) {
  switch (rank) {
    case 1:
      return 80;
    case 2:
      return 70;
    case 3:
      return 60;
    case 4:
      return 50;
    default:
      return 40;
  }
}

export function getRankedReviewList(
  reviewList: InterviewReviewItem[],
): RankedInterviewReviewItem[] {
  let rank = 1;
  let prevCount: Nullable<number> = null;
  const sorted = reviewList.sort((a, b) => b.count - a.count);

  const rankedReviewList = sorted.map((item, index) => {
    if (prevCount !== item.count) {
      rank = index + 1;
    }

    prevCount = item.count;

    return {
      ...item,
      rank,
    };
  });

  return rankedReviewList;
}
